/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const AssignPurchaseTaskPage = lazyLoad(
  () => import('./index'),
  module => module.AssignPurchaseTaskPage
);
